import { Injectable } from '@angular/core';

import { select, Store } from '@ngrx/store';
import { RouterReducerState } from '@ngrx/router-store';

import { RouterStateUrl } from '@sd-portal/shared/util';

import { State } from '..';
import * as actions from './training-requirement.actions';
import * as trainingRequirementQuery from './training-requirement.selectors';

@Injectable()
export class TrainingRequirementFacade {
  trainingRequirementSkeletonsLoading$ = this.store.pipe(
    select(trainingRequirementQuery.getTrainingRequirementSkeletonsLoading)
  );
  trainingRequirementSkeletonsLoaded$ = this.store.pipe(
    select(trainingRequirementQuery.getTrainingRequirementSkeletonsLoaded)
  );
  trainingRequirementSkeletons$ = this.store.pipe(
    select(trainingRequirementQuery.getTrainingRequirementAuditSkeletons)
  );

  trainingRequirementAuditLoading$ = this.store.pipe(
    select(trainingRequirementQuery.getTrainingRequirementAuditLoading)
  );
  trainingRequirementAuditLoaded$ = this.store.pipe(
    select(trainingRequirementQuery.getTraininigRequirementAuditLoaded)
  );
  trainingRequirementAudits$ = this.store.pipe(
    select(trainingRequirementQuery.getTrainingRequirementAudits)
  );

  warningRuleAuditLoading$ = this.store.pipe(
    select(trainingRequirementQuery.getWarningRuleAuditLoading)
  );
  warningRuleAuditLoaded$ = this.store.pipe(
    select(trainingRequirementQuery.getWarningRuleAuditLoaded)
  );
  warningRuleAudits$ = this.store.pipe(select(trainingRequirementQuery.getWarningRuleAudits));

  businessPersonWithTrainingSkeletonsLoading$ = this.store.pipe(
    select(trainingRequirementQuery.getBusinessPersonWithTrainingSkeletonsLoading)
  );
  businessPersonWithTrainingSkeletonsLoaded$ = this.store.pipe(
    select(trainingRequirementQuery.getbusinessPersonWithTrainingSkeletonsLoaded)
  );
  businessPersonWithTrainingSkeletons$ = this.store.pipe(
    select(trainingRequirementQuery.getBusinessPersonWithTrainingAuditSkeletons)
  );

  businessPersonTrainingRequirementAuditLoading$ = this.store.pipe(
    select(trainingRequirementQuery.getBusinessPersonTrainingRequirementAuditLoading)
  );
  businessPersonTrainingRequirementAuditLoaded$ = this.store.pipe(
    select(trainingRequirementQuery.getBusinessPersonTraininigRequirementAuditLoaded)
  );
  businessPersonTrainingRequirementAudits$ = this.store.pipe(
    select(trainingRequirementQuery.getBusinessPersonTrainingRequirementAudits)
  );

  trainingGroupSkeletonsLoading$ = this.store.pipe(
    select(trainingRequirementQuery.getTrainingGroupSkeletonsLoading)
  );
  trainingGroupSkeletonsLoaded$ = this.store.pipe(
    select(trainingRequirementQuery.getTrainingGroupSkeletonsLoaded)
  );
  trainingGroupSkeletons$ = this.store.pipe(
    select(trainingRequirementQuery.getTrainingGroupAuditSkeletons)
  );

  trainingGroupAuditLoading$ = this.store.pipe(
    select(trainingRequirementQuery.getTrainingGroupAuditLoading)
  );
  trainingGroupAuditLoaded$ = this.store.pipe(
    select(trainingRequirementQuery.getTrainingGroupAuditLoaded)
  );
  trainingGroupAudits$ = this.store.pipe(select(trainingRequirementQuery.getTrainingGroupAudits));
  trainingGroupTrainingRequirementAuditLoading$ = this.store.pipe(
    select(trainingRequirementQuery.getTrainingGroupTrainingRequirementAuditLoading)
  );
  trainingGroupTrainingRequirementAuditLoaded$ = this.store.pipe(
    select(trainingRequirementQuery.getTrainingGroupTrainingRequirementAuditLoaded)
  );
  trainingGroupTrainingRequirementAudits$ = this.store.pipe(
    select(trainingRequirementQuery.getTrainingGroupTrainingRequirementAudits)
  );

  constructor(
    private readonly store: Store<{
      router: RouterReducerState<RouterStateUrl>;
      sharedAudit: State;
    }>
  ) {}

  loadTrainingRequirements() {
    this.store.dispatch(actions.ResetTrainingRequirement());
    this.store.dispatch(actions.LoadTrainingRequirementSkeletons());
  }

  loadTrainingRequirementAudits(trainingRequirementId: number) {
    this.store.dispatch(actions.ResetTrainingRequirementAudit());
    this.store.dispatch(actions.LoadTrainingRequirementAudit({ trainingRequirementId }));
  }

  loadBusinessPersonWithTraining() {
    this.store.dispatch(actions.LoadBusinessPersonWithTrainingSkeletons());
  }

  loadBusinessPersonTrainingRequirementAudits(businessPersonTrainingRequirementId: number) {
    this.store.dispatch(actions.ResetTrainingRequirementAudit());
    this.store.dispatch(
      actions.LoadBusinessPersonTrainingRequirementAudit({ businessPersonTrainingRequirementId })
    );
  }

  loadWarningRuleAudits(warningRuleId: number) {
    this.store.dispatch(actions.LoadWarningRuleAudit({ warningRuleId }));
  }

  nextTrainingRequirementAuditPage(trainingRequirementId: number) {
    this.store.dispatch(actions.LoadNextPageTrainingRequirementAudit({ trainingRequirementId }));
  }

  nextBusinessPersonTrainingRequirementAuditPage(businessPersonTrainingRequirementId: number) {
    this.store.dispatch(
      actions.LoadNextPageBusinessPersonTrainingRequirementAudit({
        businessPersonTrainingRequirementId
      })
    );
  }

  nextWarningRuleAuditPage(warningRuleId: number) {
    this.store.dispatch(actions.LoadNextPageWarningRuleAudit({ warningRuleId }));
  }

  loadTrainingGroups() {
    this.store.dispatch(actions.LoadTrainingGroupSkeletons());
  }

  loadTrainingGroupAudits(trainingGroupId: number) {
    this.store.dispatch(actions.LoadTrainingGroupAudit({ trainingGroupId }));
  }
  nextTrainingGroupAuditPage(trainingGroupId: number) {
    this.store.dispatch(actions.LoadNextPageTrainingGroupAudit({ trainingGroupId }));
  }

  loadTrainingGroupTrainingRequirementAudits(trainingGroupTrainingRequirementId: number) {
    this.store.dispatch(
      actions.LoadTrainingGroupTrainingRequirementAudit({ trainingGroupTrainingRequirementId })
    );
  }
  nextTrainingGroupTrainingRequirementAuditPage(trainingGroupTrainingRequirementId: number) {
    this.store.dispatch(
      actions.LoadNextPageTrainingGroupTrainingRequirementAudit({
        trainingGroupTrainingRequirementId
      })
    );
  }
}
